import React,{useState} from "react";
import "./MissionSetup.css";
import Mission from "./Mission";

const MissionSetup = () =>{
    const [missionData ,setMissionData] = useState([{
        offeringId:null,
        missionName:"",
        ThumbnailImage:"",
        shortDescription:"",
        longDescription:"",
        sequence:null,
        coachMaxSeats:null,
        learnerMaxSeats:null,
        AdditionalInfo:""
    }]);
    
    const addMission = () =>{        
        let temp ={
            offeringId:null,
            missionName:"",
            thumbnailImage:"",
            shortDescription:"",
            longDescription:"",
            sequence:null,
            coachMaxSeats:null,
            learnerMaxSeats:null,
            AdditionalInfo:""
        };
        let tempMissionData = JSON.parse(JSON.stringify(missionData));
        tempMissionData.push(temp);
        setMissionData(tempMissionData);       
    };
    

    const handleChange = (index,data) =>{
        let tempData = JSON.parse(JSON.stringify(missionData));
        
        tempData[index]=data;
        setMissionData(tempData);
    };
return(<>
            <div className="page-header">
                <h3>Missions within the Offering</h3>                
            </div>
            <div className="mission-container">
               { missionData.map((mission,index) =>{
                     return <Mission item={mission} key={index} index={index} setMissionData={handleChange}/>;                    
               })}
                
            </div>
            <div className="add-mission-button" onClick={addMission}>
                + Add Mission</div> 
</>);
    
};
export default MissionSetup;